import { handBookApi } from "../../model/api";
import ButtonBase from "shared/ui/controls/ButtonBase";

import { ReactComponent as DownloadIcon } from "images/download.svg";

import templateRowStyles from "../../tabs/HandBooksTemplates/HandBooksTemplatesRow.module.scss";
import styles from "./TemplateDownloadButton.module.scss";

interface TemplateDownloadButtonProps {
  templateId: number;
  templateName: string;
}

const TemplateDownloadButton: React.FC<TemplateDownloadButtonProps> = ({ templateId, templateName }) => {
  const onDownload = (e: React.MouseEvent) => {
    e.stopPropagation();
    handBookApi.downloadTemplate({
      templateId,
      templateName,
    });
  };
  return (
    <ButtonBase onClick={onDownload} ghost type="button" className={templateRowStyles.downloadButton}>
      <DownloadIcon className={styles.icon} />
    </ButtonBase>
  );
};

export default TemplateDownloadButton;
